/** 差异随时间变化的小折线：灰线 + 峰值点标红。无曲线显示「数据不足」。 */
import { peakIndex, sparklinePoints } from '../format';

interface Props {
  curve?: number[] | null;
  width?: number;
  height?: number;
}

export default function Sparkline({ curve, width = 180, height = 40 }: Props) {
  const points = sparklinePoints(curve, width, height);
  if (!points) return <span className="bc-muted">数据不足</span>;
  const idx = peakIndex(curve);
  const coords = points.split(' ');
  const [px, py] = (coords[idx] ?? '0,0').split(',').map(Number);
  return (
    <svg width={width} height={height} className="bc-spark" role="img" aria-label="差异随时间变化">
      <line x1={2} x2={width - 2} y1={height - 2} y2={height - 2} stroke="#e5e7eb" strokeDasharray="3 3" />
      <polyline points={points} fill="none" stroke="#6b7280" strokeWidth={1.2} />
      {curve && Math.max(...curve) > 0 ? <circle cx={px} cy={py} r={2.6} fill="#dc2626" /> : null}
    </svg>
  );
}
